export function getFiveUrl(): string {
  const host = document.location.host

  if (host === 'gildi.demo01.lisa.is' || host === 'localhost:5173') {
    return 'https://lanavefurtest.gildi.is'
  }

  if (host === 'sjodfelagavefur.gildi.is') {
    return 'https://lanavefur.gildi.is'
  }

  return ''
}